var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"item-text":"name","item-value":"warehouseId","return-object":"","clearable":_vm.clearable,"disabled":_vm.locked,"label":_vm.label},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }